module.exports = __webpack_public_path__ + "static/media/devmatch_home.dc335061.png";